import { 
    UnstyledButton,
    Group,
    Text,
    ThemeIcon,
    Center
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface MainButtonProps {
    handler: any;
    icon: React.ReactNode;
    color: string;
    label: string;
    open: boolean;
}

export const MainButton = ({ handler, icon, color, label, open }: MainButtonProps) => {
    const { t } = useTranslation();
    return (
        <UnstyledButton
            onClick={handler}
            sx={(theme) => ({
            display: 'block',
            width: '100%',
            padding: theme.spacing.xs,
            borderRadius: theme.radius.sm,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
    
            '&:hover': {
                backgroundColor:
                theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
            },
        })}
        >
            <Group style={ open ? {} : { gap: 0 } }>
                <Center miw={47}>
                    <ThemeIcon color={color} variant="light">
                        {icon}
                    </ThemeIcon>
                </Center>
                <Text hiddenFrom='md' size="sm">
                    {t(label)}
                </Text>
                <Text visibleFrom='md' size="sm">
                    { open && t(label) }
                </Text>
            </Group>
        </UnstyledButton>
    );
}